/**
 * @description
 * https://react-icons.github.io/react-icons
 */
import * as BoxIcons from "react-icons/bi";
import * as Devicons from "react-icons/di";
import * as FontAwesomeIcons from "react-icons/fa";
import * as FlatIcons from "react-icons/fc";
import * as FeatherIcons from "react-icons/fi";
import * as GameIcons from "react-icons/gi";
import * as GithubOcticonsIcons from "react-icons/go";
import * as Ionic4Icons from "react-icons/io";
import * as Ionic5Icons from "react-icons/io5";
import * as MaterialIcons from "react-icons/md";

const CommonIcons = {
  ...BoxIcons,
  ...Devicons,
  ...FontAwesomeIcons,
  ...FeatherIcons,
  ...FlatIcons,
  ...GameIcons,
  ...GithubOcticonsIcons,
  ...Ionic4Icons,
  ...Ionic5Icons,
  ...MaterialIcons,
};

export default CommonIcons;
